export const DELETE_FLEET_REQUEST = 'DELETE_FLEET_REQUEST';
export const DELETE_FLEET_SUCCESS = 'DELETE_FLEET_SUCCESS';
export const DELETE_FLEET_FAILURE = 'DELETE_FLEET_FAILURE';

export const GET_QUICK_DATA_REQUEST = 'GET_QUICK_DATA_REQUEST';
export const GET_QUICK_DATA_SUCCESS = 'GET_QUICK_DATA_SUCCESS';
export const GET_QUICK_DATA_FAILURE = 'GET_QUICK_DATA_FAILURE';